import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';

import types from './types';
import actions from './actions';
import { getCRETeamList } from '../api';

export function* getDataFlow() {
  try {
    const response = yield call(getCRETeamList);

    yield put(
      actions.getCRETeamListSucceeded(response.data),
    );
  } catch (error) {
    yield put(
      actions.getCRETeamListFailed(
        error,
      ),
    );
  }
}

export function* watchgetCRETeamList() {
  yield takeLatest(
    types.GET_CRE_TEAM_LIST_REQUESTED,
    getDataFlow,
  );
}
export default [
  watchgetCRETeamList(),
];
